import { SelectNoteMixin } from '@/scripts/Notes/NoteDetail/mixins/SelectNoteMixin';

export default {
  name: 'VideoNoteContent',

  mixins: [SelectNoteMixin],

  props: {
    p_note: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    openNotePlayer() {
      this.selectNote();
      this.$emit('open-note-player');
    },

    /* async markVideo(payload) {
      await this.ma_addToFavoriteList({
        note: { ...this.c_currentNote },
        objUpd: {
          collected: payload.toCollect,
        },
      });
      this.currentVideo.collected = payload.toCollect;
      Swal.fire({
        width: '400px',
        backdrop: false,
        icon: 'success',
        title: `${payload.toCollect ? '收藏成功' : '已取消收藏'}`,
        showConfirmButton: false,
        timer: 800,
      });
    }, */

    clickNoteContent(e) {
      this.selectNote();
      this.$emit('click-note-content', e);
    },
  },
};
